export default __webpack_public_path__ + "static/box_w.3d48b3ad05580c1f52a5f8c8d358a012.svg";